/**
 * 
 */
export default [
    {
        text    : 'n° de factura',
        width   : '5%',
        value   : ({ invoice_number }) => invoice_number ? invoice_number : '-',
    },
    {
        text    : 'n° de orden',
        width   : '5%',
        value   : 'id',
    },
    {
        text    : 'proveedor',
        value   : ({ pch_provider }) => pch_provider.business_name,
    },
    {
        text    : 'sucursal',
        value   : ({ pch_provider_branch_offices }) => pch_provider_branch_offices.address,
    },
    {
        text    : 'recepcionado el',
        align   : 'center',
        format  : 'date',
        value   : 'receiving_date',
    },
    {
        text    : 'neto',
        align   : 'center',
        format  : 'currency',
        value   : 'net_subtotal',
    },
    {
        text    : 'iva',
        align   : 'center',
        format  : 'currency',
        value   : 'iva',
    },
    {
        text    : 'total',
        align   : 'center',
        format  : 'currency',
        value   : 'total',
    },
]
